import * as FromOther from 'reducers/rateLimits/selectors';

const SLICE = 'rateLimits';

export const getRestoringState = state =>
  FromOther.getRestoringState(state[SLICE]);

export const getNeedPassCaptcha = state =>
  FromOther.getNeedPassCaptcha(state[SLICE]);
